import { INotification } from '../interfaces/graph-types';
import { map, catchError, startWith, first, take } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import { Apollo, gql } from 'apollo-angular-boost';
import { Injectable } from '@angular/core';
import { PusherService } from './pusher.service';

type ErrorCallback = (err: string) => any;
type SuccessCallback = (data: any) => any;

@Injectable()
export class NotificationService {
  status$ = new BehaviorSubject<boolean>(true);

  notifications$ = new BehaviorSubject<INotification[]>([]);
  private allNotifications = [];

  // ------------------------------------------------------
  constructor(private pusherService: PusherService) {
    pusherService.notifications().subscribe(res => {
      console.warn('NotificationService');
      console.warn(res);
      this.addNotification({
        id: '1',
        type: res.type,
        data: res.data,
        options: res.options,
        time: res.time,
        read: false,
      });
    });
  }

  // ------------------------------------------------------
  public networkStatus(): BehaviorSubject<boolean> {
    return this.status$;
  }

  // ------------------------------------------------------
  public addNotification(notification: INotification): void {
    if (notification.options && notification.options.play_sound) {
      setTimeout(() => {
        let audio_sound = null;
        if (notification.type == 'open') {
          audio_sound = new Audio('read_event.ogg');
        }
        if (notification.type == 'click') {
          audio_sound = new Audio('click_event.ogg');
        }
        audio_sound.play();
      }, 10);
    }

    this.allNotifications.unshift(notification);
    this.notifications$.next(this.allNotifications);
  }
}
